import React from "react";
import Dropdown from "Components/DesignSystem/Dropdown/Dropdown";

type TSecondarySortOption = {
    id: string;
    label: string;
};

const COMPONENT_ID = 'secondary-sort-select';

type SecondarySortSelectProps = {
    id: string;
    value: string;
    options: TSecondarySortOption[];
    onChange: (value: string | number) => void;
    disabled?: boolean;
};

export const SecondarySortSelect = ({
    id,
    value,
    options,
    onChange,
    disabled = false,
}: SecondarySortSelectProps) => {
    return (<Dropdown
        label=""
        data-testid={`${COMPONENT_ID}-${id}`}
        value={value}
        onChange={(value) => onChange(value)}
        disabled={disabled}
        /*
            Portaled, because this Dropdown lives inside a table that has TWO clipping
            ancestors: the rounded border wrapper (`overflow-hidden`, which is what
            keeps the table's square corners inside the radius) and the horizontal
            scroll container (`overflow-x: auto`). Without a portal the listbox is a
            positioned child of the row and gets cut off at the table's edge — so the
            last rows' options were unreachable. Neither overflow can simply be
            dropped: one owns the corners, the other the horizontal scroll.
        */
        usePortal
        aria-label="Select secondary sort option"
        options={options.map((option) => (
            { "value": option.id, "label": option.label }
        ))}
    />
    );
};